import React, { useEffect, useState } from "react";
import MoneyIcon from "../../assets/Money.svg";
import PurchasedIcon from "../../assets/Purchased.svg";
import BuyTokenIcon from "../../assets/BuyToken.svg";
import SendTokenIcon from "../../assets/SendToken.svg";
import axios from "axios";
import { baseURL } from "../../services/axiosConfig";
import { refreshTokenV2 } from "../../services/api";
import { useDispatch } from "react-redux";

const TokenTransferCard = ({
  onSendTokens,
  onBuyTokens,
  availableTokens,
  setAvailableTokens
}) => {
  const [loading, setLoading] = useState(true);
  const [wonTokens, setWonTokens] = useState(0);
  const [winningamount, setWinningAmount] = useState(wonTokens * 15); // Assuming 1 token
  const dispatch = useDispatch()
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = localStorage.getItem("access_token");
        if (!token) {
          console.error("No access token found");
          setLoading(false);
          return;
        }

        const response = await axios.get(`${baseURL}/accounts/user/me`, {
          headers: {
            Authorization: `Bearer ${JSON.parse(token)}`,
          },
        });
        if (response.status === 200) {
          setAvailableTokens(response.data.available_tokens || 0);
          setWinningAmount(response.data.winningamount || 0);
          setWonTokens(response.data.won_tokens || 0);
        }
      } catch (error) {
        console.error("Error fetching profile:", error);
        if (error?.response?.status === 401) {
          await refreshTokenV2(dispatch);
          fetchProfile(); // Retry after refresh
        }
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  // Optional: Show loading spinner or placeholder while fetching
  // if (loading) {
  //   return <div>Loading wallet data...</div>;
  // }

  // Calculate dollar amount (1 token = $15)
  const dollarAmount = (wonTokens * 15).toFixed(2);

  console.log(wonTokens)

  return (
    <div className="py-2 px-3 sm:px-6 bg-[#F6FAFF] w-full token-transfer-card">
      <div className="max-w-7xl xl:max-w-[1600px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between bg-[#082642] border border-[#3aa0ff] rounded-lg p-4 sm:p-6 shadow-lg w-full gap-4 sm:gap-6">
          {/* Left group */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 w-full md:flex md:flex-row md:items-center md:w-auto">
            {/* Available Purchased Tokens (now from backend) */}
            <div className="flex items-start sm:items-center gap-3 sm:gap-4 bg-[#606060] bg-opacity-20 rounded-lg px-4 sm:px-6 py-4 sm:py-8 w-full md:w-auto">
              <img
                src={PurchasedIcon}
                alt="Purchased Tokens"
                className="w-10 h-10 sm:w-[50px] sm:h-[50px] purchased-icon"
              />
              <div className="text-left">
                <div className="font-archivo capitalize text-xs sm:text-sm text-gray-400 mb-1 token-label">
                  Available Purchased Tokens
                </div>
                <div className="font-archivo text-white text-2xl sm:text-[37px] leading-none token-count">
                  {availableTokens}{" "}
                  <span className="text-2xl sm:text-[37px] font-medium token-unit">
                    Tokens
                  </span>
                </div>
              </div>
            </div>

            {/* Total Amount Won */}
            <div className="flex items-start sm:items-center gap-3 sm:gap-4 bg-[#606060] bg-opacity-20 rounded-lg px-4 sm:px-4 py-4 sm:py-5 w-full md:w-auto">
              <img
                src={MoneyIcon}
                alt="Total Amount Won"
                className="w-12 h-12 sm:w-[60px] sm:h-[60px] money-icon"
              />
              <div className="text-left">
                <div className="font-archivo capitalize text-xs sm:text-base font-medium leading-none tracking-tight text-gray-400 token-label">
                  Total Amount Won
                </div>
                <div className="font-archivo text-white font-semibold text-2xl sm:text-[37px] leading-none mt-1 token-dollars">
                  <span>$ </span>
                  {Number(winningamount).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}
                </div>
                <div className="font-archivo text-[12px] sm:text-[14px] text-gray-400 font-medium mt-1 tracking-wide token-subtext">
                  ({wonTokens} Tokens)
                </div>
              </div>
            </div>
          </div>

          {/* Right: Buttons */}
          <div className="grid grid-cols-2 sm:flex sm:flex-row gap-2 sm:gap-3 w-full md:w-auto">
            <button
              onClick={onSendTokens}
              className="flex items-center justify-center gap-2 bg-[#FFFFFF14] bg-opacity-60 hover:bg-[#1e3c5e] text-white px-2 sm:px-5 py-1.5 sm:py-3 rounded-md transition-colors w-full text-xs sm:text-base"
            >
              <img
                src={SendTokenIcon}
                alt="Send Tokens"
                className="w-6 h-6 sm:w-10 sm:h-10 send-icon"
              />
              <span className="font-archivo font-semibold text-xs sm:text-[15px] leading-none whitespace-nowrap">
                Send Tokens
              </span>
            </button>

            <button
              onClick={onBuyTokens}
              className="flex items-center justify-center gap-2 bg-[#FFFFFF14] bg-opacity-60 hover:bg-[#1e3c5e] text-white px-2 sm:px-5 py-1.5 sm:py-3 rounded-md transition-colors w-full text-xs sm:text-base"
            >
              <img
                src={BuyTokenIcon}
                alt="Buy Tokens"
                className="w-6 h-6 sm:w-10 sm:h-10 buy-icon"
              />
              <span className="font-archivo font-semibold text-xs sm:text-[15px] leading-none buy-label">
                Buy Tokens
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TokenTransferCard;